import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { ColumnProvider } from '../interfaces/ColumnProvider';
import { createEmptyArrays } from './createEmptyArrays';
import { getColumnRange } from './getColumnRange';
import { SurfaceItem } from '../interfaces/SurfaceItem';
import { VisibleTime } from 'owa-calendar-surface-core';

/**
 * Spreads the given models, represented by their date ranges, into columns.
 * @returns A two-dimensional array where the first level represents columns in the view
 * and the second level contains the models that appear in the corresponging column.
 * NOTE: Models might be included in multiple columns in the resulting array.
 */
export default function resolveAllDayColumnsWithItems(
    models: CalendarEvent[],
    store: VisibleTime,
    columnProvider: ColumnProvider
): SurfaceItem[][] {
    const columnCount = columnProvider.columnCount;
    const result = createEmptyArrays<SurfaceItem>(columnCount);

    for (const model of models) {
        let intervals = columnProvider.getColumnIntervals(model);
        const { start } = getColumnRange(intervals[0], columnCount, store.dayLength);
        intervals.forEach((interval, i) => {
            result[start + i].push({
                ...interval,
                ...{
                    model: model,
                    key: model.ItemId.Id + i,
                },
            });
        });
    }

    return result;
}
